import * as Sentry from "@sentry/react";

Sentry.init({
  enabled: import.meta.env.VITE_SENTRY_ENABLED === "true",
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_BS_ENV,
  release: import.meta.env.VITE_APP_BUNDLE_VERSION,

  replaysSessionSampleRate: 0.6,
  replaysOnErrorSampleRate: 0.6,
  tracesSampleRate: 0.6,
  sendDefaultPii: false,

  _experiments: {
    enableLogs: true,
  },

  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: true,
    }),
    Sentry.browserTracingIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.httpContextIntegration(),
    Sentry.replayCanvasIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] })
  ],
});
